import http from './httpRequest.js'

class RtcPrivateApi {
}

// 声网架构下呼叫不再需要携带 SDP offer, 服务端直接返回本端的入会信息
// { appId, channel, uid, token, mode }
RtcPrivateApi.prototype.call = function (uid, mode) {
	return http({
		url: `/webrtc/private/call?uid=${uid}&mode=${mode}`,
		method: 'post'
	})
}

// 接听同样不再需要 SDP answer, 服务端返回被叫自己的入会信息
RtcPrivateApi.prototype.accept = function (uid) {
	return http({
		url: `/webrtc/private/accept?uid=${uid}`,
		method: 'post'
	})
}


RtcPrivateApi.prototype.handup = function (uid) {
	return http({
		url: `/webrtc/private/handup?uid=${uid}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.cancel = function (uid) {
	return http({
		url: `/webrtc/private/cancel?uid=${uid}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.reject = function (uid) {
	return http({
		url: `/webrtc/private/reject?uid=${uid}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.failed = function (uid, reason) {
	return http({
		url: `/webrtc/private/failed?uid=${uid}&reason=${encodeURIComponent(reason)}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.heartbeat = function (uid) {
	return http({
		url: `/webrtc/private/heartbeat?uid=${uid}`,
		method: 'post'
	})
}

// 页面重新可见时对齐服务端状态用。纯查询接口, GET 可安全重试
RtcPrivateApi.prototype.status = function (uid) {
	return http({
		url: `/webrtc/private/status?uid=${uid}`,
		method: 'get'
	})
}

export default RtcPrivateApi;